export enum QuestionTitleSizes {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}
